module.exports = __webpack_public_path__ + "static/media/Mobex-newlogo.49399d66.svg";